import secureLocalStorage from "react-secure-storage";
import { useAuth } from "../../../context/auth";
import { useEffect, useMemo, useState } from "react";
import {
  DeleteProduct,
  DeleteUser,
  GetEmbalagens,
  GetProduto,
  GetSuppliersByUnity,
  GetUsers,
  GetUsersUnidade,
  PostProduct,
} from "../../../data/services";
import ConfirmDeleteModal from "../components/ConfirmDeleteModal";
import { toast } from "react-toastify";
import AdicionarProdutos from "./AdicionarProdutos";

type Embalagem = {
  material: string;
  idEmbalagem: number;
};

const AdminProdutos = () => {
  const { user } = useAuth();
  const profile = user.profile;

  if (profile === "usuarioFornecedor") window.location.href = "/home";
  const token: any = secureLocalStorage.getItem("access_token");
  if (!token) {
    window.location.href = "/";
  }
  const UnidadeAdmin = "adminUnidade";
  const SuperAdmin = "superAdmin";
  const adm = profile === SuperAdmin || profile === UnidadeAdmin;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openAdicionar, setOpenAdicionar] = useState(false);
  const [produtosOption, setProdutosOption] = useState<any[]>([]);
  const [selectedProduto, setSelectedProduto] = useState<any>(null);
  const [embalagens, setEmbalagens] = useState<Embalagem[]>([]);

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  useEffect(() => {
    GetProduto(setProdutosOption);
    GetEmbalagens(setEmbalagens);
  }, []);

  const handleConfirmDelete = async () => {
    try {
      await DeleteProduct(selectedProduto.idProduto);
      toast.success("Produto deletado com sucesso!");
      setProdutosOption((prev: any[]) =>
        prev.filter((item) => item.idProduto !== selectedProduto.idProduto)
      );
    } catch (error) {
      toast.error("Erro ao deletar produto.");
    } finally {
      toggleModal();
    }
  };

  const handleSaveProduto = async (produto: {
    produto: string;
    embalagens: Embalagem[];
  }) => {
    try {
      // Supondo que você queira salvar apenas o primeiro item da lista de embalagens
      const { produto: nomeProduto, embalagens } = produto;
      const embalagem = embalagens[0];
      await PostProduct({
        produto: nomeProduto,
        idEmbalagem: embalagem?.idEmbalagem,
        material: embalagem?.material,
      });
      setOpenAdicionar(false);
      toast.success("Produto salvo com sucesso!");
      // Atualizar lista de produtos
      GetProduto(setProdutosOption);
      GetEmbalagens(setEmbalagens);
      return true;
    } catch (error) {
      return false;
    }
  };

  const ListColumns = useMemo(() => {
    return (
      <>
        <td className="listProperty">Tipo de produto</td>
        <td className="listProperty">Tipo de material</td>
        {adm && <td className="listProperty">Ações</td>}
      </>
    );
  }, []);

  const List = useMemo(() => {
    return (
      <>
        {produtosOption
          ?.sort(function (a: any, b: any) {
            if (a.produto > b.produto) {
              return 1;
            }
            if (a.produto < b.produto) {
              return -1;
            }
            return 0;
          })
          .map((item: any) => {
            return (
              <tr
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: 5,
                  borderBottom: "1px solid #dddddd",
                }}
              >
                <td className="listTd">{item.produto ? item.produto : "~~"}</td>
                <td className="listTd">
                  {item.material ? item.material : "~~"}
                </td>
                {/* <td className="listProperty">Tipo de defeito</td> */}
                <div style={{ display: "flex", flex: 1, marginLeft: 3 }}>
                  {/* removido pois cada produto está vinculado a um idProduto, se editar teria que vir todas embalagens */}
                  {/* <button
                    className="editBtn"
                    onClick={() => {
                      setOpen((prev: any) => ({
                        ...prev,
                        open: true,
                        method: "putch",
                      }));
                      setInfo(item);
                    }}
                  >
                    Editar
                  </button> */}
                  <button
                    className="deleteUserBtn"
                    onClick={() => {
                      setSelectedProduto(item);
                      setIsModalOpen(true);
                    }}
                  >
                    Deletar
                  </button>
                </div>
              </tr>
            );
          })}
      </>
    );
  }, [produtosOption]);

  return (
    <div className="modalSignUp">
      <div className="content-header-button-and-title">
        <h1>Produtos</h1>

        {adm && (
          <button className="BtnClean" onClick={() => setOpenAdicionar(true)}>
            Adicionar
          </button>
        )}
      </div>

      <div className="contentList">{ListColumns}</div>
      <div className="content">
        <div className="containerListInfo">
          {produtosOption.length > 0 ? (
            <>{List}</>
          ) : (
            <div style={{ textAlign: "center" }}>
              <h1 style={{ margin: "35px 0", fontSize: 28 }}>
                Não há registros aqui
              </h1>
            </div>
          )}
        </div>
      </div>

      {openAdicionar && (
        <AdicionarProdutos
          embalagens={embalagens}
          onSave={handleSaveProduto}
          onCancel={() => setOpenAdicionar(false)}
        />
      )}

      <ConfirmDeleteModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        onConfirm={handleConfirmDelete}
        itemName={selectedProduto?.produto ?? ""}
      />
    </div>
  );
};
export default AdminProdutos;
